
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from "redux-persist/lib/storage"; // LocalStorage as default
import countriesReducer from './slices/countriesSlice';
import permissionsReducer from "./slices/permissionsSlice";
import notificationSlice from './slices/notificationSlice';
import userSlice from './slices/userSlice'

const persistConfig = {
  key: "permissions",
  storage,
};

const persistedPermissionsReducer = persistReducer(persistConfig, permissionsReducer);
const persistedCountriesReducer = persistReducer(persistConfig, countriesReducer);


export const store = configureStore({
  reducer: {
    countries: persistedCountriesReducer,
    permissions: persistedPermissionsReducer,
    notification: notificationSlice,
    user: userSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});



export const persistor = persistStore(store);
